<comment>
ローディングアイコン
</comment>

<template>
  <div class="loadingIcon" style="display: block;">
    <div class="loadingIcon__inner">
      <div class="loadingIcon__parts--01 loadingIcon__parts"></div>
      <div class="loadingIcon__parts--02 loadingIcon__parts"></div>
      <div class="loadingIcon__parts--03 loadingIcon__parts"></div>
      <div class="loadingIcon__parts--04 loadingIcon__parts"></div>
      <div class="loadingIcon__parts--05 loadingIcon__parts"></div>
      <div class="loadingIcon__parts--06 loadingIcon__parts"></div>
      <div class="loadingIcon__parts--07 loadingIcon__parts"></div>
      <div class="loadingIcon__parts--08 loadingIcon__parts"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loadingIcon',
}
</script>

<style lang="scss" scoped>
@keyframes fade {
  0%{
    background-color:#000000
  }
  100%{
    background-color:#FFFFFF
  }
}

.loadingIcon {
  position: absolute;
  opacity: 0.7;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);

  &__inner{
    position:relative;
    width:40px;
    height:50px;
    top: 10px;
    margin: 0 auto;
  }

  &__parts{
    position:absolute;
    background-color:#FFFFFF;
    width:6px;
    height:16px;
    border-radius:6px 6px 0 0;
    transform:scale(0.4);
    animation: fade 0.88s linear 0s infinite normal;

    &--01{
      left:0;
      top:18px;
      animation-delay:0.33s;
      transform:rotate(-90deg);
    }

    &--02{
      left:5px;
      top:6px;
      animation-delay:0.44s;
      transform:rotate(-45deg);;
    }

    &--03{
      left:17px;
      top:2px;
      animation-delay:0.55s;
      transform:rotate(0deg);
    }

    &--04{
      right:5px;
      top:6px;
      animation-delay:0.66s;
      transform:rotate(45deg);
    }

    &--05{
      right:0;
      top:18px;
      animation-delay:0.77s;
      transform:rotate(90deg);
    }

    &--06{
      right:5px;
      bottom:5px;
      animation-delay:0.88s;
      transform:rotate(135deg);
    }

    &--07{
      bottom:0;
      left:17px;
      animation-delay:0.99s;
      transform:rotate(180deg);
    }

    &--08{
      left:5px;
      bottom:5px;
      animation-delay:1.1s;
      transform:rotate(-135deg);
    }
  }
}
</style>